import { activeDomainImage, entityPhotoHasImage, resolveEntityPhotoUrl } from '../../../utils/imageProxy';
import { getEntityImageConfig } from '../../entityImage/entityImageConfig';
import EntityPhotoFrame from '../../entityImage/EntityPhotoFrame';
import OpenImageDialog from '../../openImageDialog';
import { Box } from '@mui/material';
import Iconify from '../../Iconify';
import { useState } from 'react';
import '../../../css/sites/siteImageActions.css';

const PHOTO_OPTS = (({ imageField, documentField }) => ({ imageField, documentField }))(
    getEntityImageConfig('articleFolder'),
);

/** Public QR cover: keys are already signed by the API, no editing affordance. */
const PublicArticleFolderImageActions = ({ articleFolder }) => {

    const [openImage, setOpenImage] = useState(false);
    const hasImage = entityPhotoHasImage(articleFolder, { ...PHOTO_OPTS, size: 'medium' });

    if (!hasImage) {
        return null;
    }

    const image = activeDomainImage(articleFolder, PHOTO_OPTS.imageField);
    const mainUrl = resolveEntityPhotoUrl(articleFolder, { ...PHOTO_OPTS, size: 'medium' });
    const fullUrl = resolveEntityPhotoUrl(articleFolder, { ...PHOTO_OPTS, size: 'default', fallback: '' });

    return (
        <Box>
            <EntityPhotoFrame
                image={image}
                src={mainUrl}
                alt="Image du dossier"
                className="siteImageActions_image_icon_box"
            >
                {fullUrl && (
                    <Iconify className='siteImageActions_maximize_icon' icon={"tabler:arrows-maximize"} onClick={() => setOpenImage(true)} />
                )}
            </EntityPhotoFrame>
            {openImage &&
                <OpenImageDialog
                    openImage={openImage}
                    setOpenImage={setOpenImage}
                    profileUrl={fullUrl}
                />
            }
        </Box>
    )
}

export default PublicArticleFolderImageActions
